/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Marketing_Emphasis_TitleInputs */

const en_wb_marketing_emphasis_title = /** @type {(inputs: Wb_Marketing_Emphasis_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Worth looking at`)
};

const lv_wb_marketing_emphasis_title = /** @type {(inputs: Wb_Marketing_Emphasis_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vērts pievērst uzmanību`)
};

/**
* | output |
* | --- |
* | "Worth looking at" |
*
* @param {Wb_Marketing_Emphasis_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_marketing_emphasis_title = /** @type {((inputs?: Wb_Marketing_Emphasis_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Marketing_Emphasis_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_marketing_emphasis_title(inputs)
	return en_wb_marketing_emphasis_title(inputs)
});